import React from 'react';
import DaumPostcode, { AddressData } from 'react-daum-postcode';
import useCoordsQuery from '@/hooks/common/useCoordsQuery';

interface Props {
  setAddressForm: (data: AddressForm) => void;
  setPostCodeModal: (on: boolean) => void;
}

const PostCode = (props: Props) => {
  const { setAddressForm, setPostCodeModal } = props;
  const { getCoordsMutation } = useCoordsQuery();

  const handleComplete = async (data: AddressData) => {
    const roadAddress = data.roadAddress;
    const jibunAddress = data.jibunAddress;
    const autoJibunAddress = data.autoJibunAddress;
    const zonecode = data.zonecode;

    const coordsData = await getCoordsMutation.mutateAsync(data.address);
    const targetCoords = coordsData?.documents[0];
    if (!targetCoords) return alert('좌표를 읽어오지 못했습니다.');

    const { x: longitude, y: latitude } = targetCoords;

    await setAddressForm({
      roadAddress,
      jibunAddress: jibunAddress || autoJibunAddress,
      longitude,
      latitude,
      zonecode
    });

    await setPostCodeModal(false);
  };

  const onSearch = () => {
    return;
  };

  return (
    <DaumPostcode onComplete={handleComplete} onSearch={onSearch} autoClose />
  );
};

export default PostCode;
